import React from "react";
import img from "../../../core/common/imageWithBasePath";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";

const InternalServerError = () => {
  const routes = all_routes;
  return (
    <div className="container">
      <div className="vh-100 d-flex align-items-center justify-content-center">
        <div className="row w-100">
          {/* Left Panel - Message */}
          <div className="col-md-6 d-flex flex-column justify-content-center align-items-center text-center">
            <div className="mb-4">
              <img
                src="./assets/img/logo/weconnectlogo.png"
                alt="WeConnect Logo"
                className="img-fluid"
                style={{ maxWidth: "180px" }}
              />
            </div>
            <h1 className="mb-3 fw-bold text-danger">Internal Server Error</h1>
            <p className="fs-10 text-muted px-3">
              Something went wrong on our end. Please try again later or contact
              your administrator if the issue persists.
            </p>
            <Link
              to={all_routes.employeeDashboard}
              className="btn btn-primary custom_button mt-4 d-flex align-items-center"
            >
              <i className="ti ti-arrow-left me-2" />
              Back to Dashboard
            </Link>
          </div>

          {/* Right Panel - Illustration */}
          <div className="col-md-6 d-flex justify-content-center align-items-center">
            <img
              src="./assets/img/error-500.svg" 
              alt="Internal Server Error Illustration"
              className="img-fluid"
              style={{ maxHeight: "400px" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InternalServerError;
